import { create } from 'zustand';

const useDropdownStore = create((set) => ({
  openDropdownId: null,
  setOpenDropdown: (id) => set({ openDropdownId: id }),
  closeAllDropdowns: () => set({ openDropdownId: null })
}));

export default useDropdownStore;